// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__KVJJv","controls":"styles_controls__YaXD-","charLimit":"styles_charLimit__zLHaQ","input":"styles_input__23pab","send":"styles_send__htl9r"};